(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('companyOperations', CompanyOperations);

    /** @ngInject */
    function CompanyOperations($q, $rootScope, CompanyOperationService, LoadingHelper, UtilHelper, PATHS) {
        function CompanyOperationsDirectiveController($scope) {
            const vm = this;

            let removeWatchShow = $scope.$watch('vm.show', (newValue, oldValue) => {
                if (newValue)
                    init();
            });

            $scope.$on('$destroy', () => {
                removeWatchShow();
            });

            vm.saveWorkingTime = () => {
                LoadingHelper.startLoading('.loading-holder');

                vm.workingTimes.forEach(time => {
                    if (time.Closed || (!time.Closed && (time.StartHourId == null || time.EndHourId == null))) {
                        time.StartHourId = null;
                        time.EndHourId = null;
                        time.Closed = true;
                    }
                })

                if (vm.workingTimes[0].Id) {
                    CompanyOperationService
                        .put(vm.workingTimes)
                        .then(success => {
                            vm.workingTimes = success;

                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.successCallback('update');
                        }, error => {
                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.errorCallback(error);
                        })
                } else {
                    CompanyOperationService
                        .post(vm.workingTimes)
                        .then(success => {
                            vm.workingTimes = success;

                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.successCallback();
                        }, error => {
                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.errorCallback(error);
                        })
                }
            }

            function prepareWorkingTimeWeek() {
                const companyId = vm.companyData.Id;

                for (let index = 0; index < vm.weekDays.length; index++) {
                    let weekDay = vm.weekDays[index];
                    let workingTime = vm.workingTimes.find(wt => wt.WeekDayId == weekDay.Id);

                    if (!workingTime) {
                        let newWorkingTime = {
                            StartHourId: null,
                            EndHourId: null,
                            WeekDayId: weekDay.Id,
                            WeekDay: weekDay,
                            CompanyId: companyId,
                            Closed: false
                        };

                        vm.workingTimes.push(newWorkingTime);
                    }
                }
            }

            function getHours() {
                return CompanyOperationService
                    .getHours()
                    .then(success => {
                        let hours = success.filter(x => x.Active);

                        hours.forEach(hour => {
                            hour.momentHour = moment()
                                .hours(hour.Horary.substring(0, 2))
                                .minutes(hour.Horary.substring(3, 5))
                        });

                        vm.hours = hours;

                        LoadingHelper.stopLoading('.loading-holder');
                    }, error => {
                        LoadingHelper.stopLoading('.loading-holder');
                        UtilHelper.errorCallback(error);
                    });
            }

            function initVars() {
                vm.canUserEdit = $rootScope.canUserEdit;

                vm.weekDays = [{
                    Id: 2,
                    Day: 'Segunda-feira',
                    Class: 'purple'
                }, {
                    Id: 3,
                    Day: 'Terça-feira',
                    Class: 'purple'
                }, {
                    Id: 4,
                    Day: 'Quarta-feira',
                    Class: 'purple'
                }, {
                    Id: 5,
                    Day: 'Quinta-feira',
                    Class: 'purple'
                }, {
                    Id: 6,
                    Day: 'Sexta-feira',
                    Class: 'purple'
                }, {
                    Id: 7,
                    Day: 'Sábado',
                    Class: 'orange'
                }, {
                    Id: 1,
                    Day: 'Domingo',
                    Class: 'orange'
                }]
            }

            function init() {
                LoadingHelper.startLoading('.loading-holder');

                vm.workingTimes = vm.companyData.CompanyOperations || [];

                initVars();

                $q.all([getHours()])
                    .then(() => {
                        prepareWorkingTimeWeek();
                    });
            }
        }

        return {
            bindToController: true,
            controller: CompanyOperationsDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/company-operations/company-operations.html`,
            scope: {
                companyData: '=',
                show: '='
            }
        }
    }
}());